import { render, staticRenderFns } from "./AdditionalFieldsDecimalNumber.vue?vue&type=template&id=2a094e74&scoped=true&lang=pug&"
import script from "./AdditionalFieldsDecimalNumber.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsDecimalNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a094e74",
  null
  
)

export default component.exports